var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00008 6.6665C4.73646 6.6665 5.33341 7.26346 5.33341 7.99984C5.33341 8.73622 4.73646 9.33317 4.00008 9.33317C3.2637 9.33317 2.66675 8.73622 2.66675 7.99984C2.66675 7.26346 3.2637 6.6665 4.00008 6.6665Z",
    fill: "#405BD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 6.6665C8.73646 6.6665 9.33341 7.26346 9.33341 7.99984C9.33341 8.73622 8.73646 9.33317 8.00008 9.33317C7.2637 9.33317 6.66675 8.73622 6.66675 7.99984C6.66675 7.26346 7.2637 6.6665 8.00008 6.6665Z",
    fill: "#405BD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 6.6665C12.7365 6.6665 13.3334 7.26346 13.3334 7.99984C13.3334 8.73622 12.7365 9.33317 12.0001 9.33317C11.2637 9.33317 10.6667 8.73622 10.6667 7.99984C10.6667 7.26346 11.2637 6.6665 12.0001 6.6665Z",
    fill: "#405BD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.da6e649c80bdee4b4dc5b4b96e491805.svg";
export { ForwardRef as ReactComponent };